function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */

import React, { Component, Fragment, createRef } from 'react';
import Types from 'prop-types';
import focusWithin from 'focus-within';
import classnames from 'classnames';
import ItemContent from './ItemContent';
import CardDropdown from './CardDropdown';
import LanguageSelector from './LanguageSelector';
import ButtonItem from '../../../ButtonItem';
import isActiveLink from '../../../../../common/utils/isActiveLink';
import { CountryLanguageSelector } from './CountryLanguageSelector';
import { LocaleValues } from '../../../../../common/l10n';
polyfillFocusWithinIfInBrowser();
var Item = /*#__PURE__*/function (_Component) {
  _inherits(Item, _Component);
  var _super = _createSuper(Item);
  function Item() {
    var _this;
    _classCallCheck(this, Item);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "nodeRef", /*#__PURE__*/createRef());
    _defineProperty(_assertThisInitialized(_this), "mobileViewportQuery", null);
    _defineProperty(_assertThisInitialized(_this), "state", {
      isOpen: false,
      isMobileViewport: false
    });
    _defineProperty(_assertThisInitialized(_this), "handleMouseDown", function (event) {
      var target = event.target;
      var link = target.tagName.toLowerCase() === 'span' ? target.parentElement : target;
      if (link.tagName.toLowerCase() === 'a') {
        event.stopPropagation();
        link.click();
      } else {
        defer(function () {
          return link.blur();
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "toggleDropdown", function () {
      _this.setState(function (prevState) {
        return {
          isOpen: !prevState.isOpen
        };
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleViewportChange", function (_ref) {
      var matches = _ref.matches;
      _this.setState({
        isMobileViewport: matches
      });
    });
    return _this;
  }
  _createClass(Item, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mobileViewportQuery = window.matchMedia('(max-width: 991px)');
      var isMobileViewport = this.mobileViewportQuery.matches;
      this.setState({
        isMobileViewport: isMobileViewport
      });
      this.mobileViewportQuery.addListener(this.handleViewportChange);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mobileViewportQuery.removeListener(this.handleViewportChange);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        id = _this$props.id,
        translationKey = _this$props.translationKey,
        translatedText = _this$props.translatedText,
        link = _this$props.link,
        Icon = _this$props.Icon,
        items = _this$props.items,
        analyticsId = _this$props.analyticsId,
        badge = _this$props.badge,
        main = _this$props.main,
        isButton = _this$props.isButton,
        isTitle = _this$props.isTitle,
        inverse = _this$props.inverse,
        deEmphasize = _this$props.deEmphasize,
        isLanguageSelector = _this$props.isLanguageSelector,
        language = _this$props.language,
        availableLanguages = _this$props.availableLanguages,
        onLanguageChange = _this$props.onLanguageChange,
        activePath = _this$props.activePath,
        isInSubMenu = _this$props.isInSubMenu,
        linkTarget = _this$props.linkTarget,
        onCloseMenu = _this$props.onCloseMenu,
        isPillNavigation = _this$props.isPillNavigation,
        locale = _this$props.locale,
        availableLocales = _this$props.availableLocales,
        onLocaleChange = _this$props.onLocaleChange,
        withCountrySelector = _this$props.withCountrySelector;
      var _this$state = this.state,
        isOpen = _this$state.isOpen,
        isMobileViewport = _this$state.isMobileViewport;
      if (isLanguageSelector) {
        if (availableLanguages && withCountrySelector && onLanguageChange) {
          return /*#__PURE__*/React.createElement(CountryLanguageSelector, {
            key: "".concat(language, "-").concat(locale),
            locale: locale,
            availableLocales: availableLocales,
            onLocaleChange: onLocaleChange,
            language: language,
            availableLanguages: availableLanguages,
            onLanguageChange: onLanguageChange
          });
        }
        if (!withCountrySelector && availableLanguages && availableLanguages.length > 1 && onLanguageChange) {
          return /*#__PURE__*/React.createElement(LanguageSelector, {
            language: language,
            availableLanguages: availableLanguages,
            onLanguageChange: onLanguageChange
          });
        }
        return null;
      }
      if (isButton) {
        return /*#__PURE__*/React.createElement(ButtonItem, {
          translationKey: translationKey,
          link: link,
          inverse: inverse,
          deEmphasize: deEmphasize,
          linkTarget: linkTarget
        });
      }
      var hasItems = !!(items && items.length > 0);
      var linkClassName = classnames({
        'visible-xs visible-sm': hasItems,
        'tw-public-nav__title': isTitle
      }, 'tw-link-with-chevron', 'btn', 'btn-sm', 'btn-accent', 'btn-priority-2');
      var itemContent = /*#__PURE__*/React.createElement(ItemContent, {
        translationKey: translationKey,
        Icon: Icon,
        hasCaret: hasItems,
        badge: badge,
        translatedText: translatedText,
        isPillNavigation: isPillNavigation,
        activePath: activePath,
        link: link
      });
      return /*#__PURE__*/React.createElement("li", {
        onMouseDown: this.handleMouseDown,
        className: classnames('tw-public-nav__item', {
          'tw-public-nav__pill-item': isPillNavigation,
          'tw-public-nav__dropdown': hasItems,
          active: isInSubMenu && isActiveLink(link, activePath),
          'tw-public-nav__menu-item-help': id === 'help'
        }),
        "data-analytics-id": analyticsId,
        ref: this.nodeRef
      }, /*#__PURE__*/React.createElement(Fragment, null, !hasItems && /*#__PURE__*/React.createElement("a", {
        href: link,
        className: linkClassName,
        target: linkTarget
      }, itemContent), hasItems && /*#__PURE__*/React.createElement("button", {
        className: classnames('tw-public-nav__dropdown-toggle tw-link-with-chevron', {
          'is-dropdown-open': isOpen
        }),
        type: "button",
        onClick: this.toggleDropdown
      }, itemContent)), hasItems && /*#__PURE__*/React.createElement(CardDropdown, {
        items: items,
        mainCTA: main,
        itemId: id,
        activePath: activePath,
        isOpen: isMobileViewport ? isOpen : true,
        onCloseMenu: onCloseMenu,
        isPillNavigation: isPillNavigation
      }));
    }
  }]);
  return Item;
}(Component);
_defineProperty(Item, "defaultProps", {
  id: '',
  translationKey: '',
  link: null,
  items: null,
  analyticsId: null,
  badge: '',
  main: null,
  Icon: null,
  isButton: false,
  isTitle: false,
  inverse: false,
  deEmphasize: false,
  isLanguageSelector: false,
  activePath: undefined,
  translatedText: '',
  isInSubMenu: false,
  linkTarget: undefined,
  isPillNavigation: false,
  onCloseMenu: function onCloseMenu() {},
  availableLanguages: null,
  availableLocales: null,
  onLanguageChange: function onLanguageChange() {},
  onLocaleChange: function onLocaleChange() {},
  locale: '',
  withCountrySelector: false
});
function polyfillFocusWithinIfInBrowser() {
  if (typeof document !== 'undefined') {
    focusWithin(document, {
      attr: false,
      className: 'focus-within'
    });
  }
}
function defer(fn) {
  setTimeout(fn, 0);
}
export default Item;